<template>
  <div>
    <!-- aigosmart -->
    <div class="content" v-if="brand=='aigosmart'">
      <div class="my-header">
        <img class="bg" src="../assets/300325168.png" alt="Fluid image" />

        <div class="logo-layout">
          <img class="logo" src="../assets/sdf.png" />
          <img class="glabol" src="../assets/asdcw.png" />

          <b-dropdown :text="currentLang" variant="red" class="m-2" style="margin-bottom:-10px" menu-class="lauange">
            <b-dropdown-item href="#" @click="changeLang('zh-ch', '中文')">中文</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('es', 'Español')">Español</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('fr', 'Français')">Français</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('de', 'Deutsch')">Deutsch</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('en', 'English')">English</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pt', 'Português')">Português</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('it', 'Italiano')">Italiano</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nl', 'Nederland')">Nederland</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pl', 'Polska')">Polska</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('da', 'Denmark')">Denmark</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nb', 'Norway')">Norway</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('sv', 'Sverige')">Sverige</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('hu', 'Magyarország')">Magyarország</b-dropdown-item>

          </b-dropdown>
        </div>
      </div>
      <!-- 手机头部 -->
      <div class="mobile-header">
        <div class="left">
          <img src="../assets/sdf.png" />
        </div>
        <div class="right">
          <img style="width: 25px;height: 24px;margin-top: 22px; margin-right: -7px;" src="../assets/asdcw.png" />
          <b-dropdown :text="currentLang" variant="red" class="m-2" style="margin-bottom:-10px" menu-class="lauange">
            <b-dropdown-item href="#" @click="changeLang('zh-ch', '中文')">中文</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('es', 'Español')">Español</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('fr', 'Français')">Français</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('de', 'Deutsch')">Deutsch</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('en', 'English')">English</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pt', 'Português')">Português</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('it', 'Italiano')">Italiano</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nl', 'Nederland')">Nederland</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pl', 'Polska')">Polska</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('da', 'Denmark')">Denmark</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nb', 'Norway')">Norway</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('sv', 'Sverige')">Sverige</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('hu', 'Magyarország')">Magyarország</b-dropdown-item>

          </b-dropdown>
        </div>
      </div>
      <div class="mobile-banner">
        <img src="../assets/300325168.png" />

      </div>

      <b-container fluid class="bv-example-row">
        <b-row>
          <b-col xl="6" md="12">
            <div class="text-layout">
              <div class="title">{{$t('message.title1')}}</div>
              <div class="content">
                {{$t('message.content1')}}
              </div>
            </div>
          </b-col>
          <b-col xl="6" md="12">
            <div class="text-layout">
              <img class="banner1" src="../assets/asfcev.png" />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col xl="6" md="12">
            <div class="text-layout" style="justify-content: flex-end; height: 340px;">
              <img class="banner2" src="../assets/123193411.png" />
            </div>
          </b-col>
          <b-col xl="6" md="12">
            <div class="text-layout" style="justify-content: flex-end; height: 340px;">
              <div class="title"> {{$t('message.title2')}}</div>
              <div class="content">
                {{$t('message.content2')}}
              </div>
              <div class="content" style="margin-top:5px">
                {{$t('message.content3')}}<img class="amazon" src="../assets/amze.png" />
                {{$t('message.content4')}}
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row style="margin-top:40px;margin-bottom:100px">
          <b-col xl="6" md="12">
            <div class="text-layout" style="justify-content: flex-end;">
              <div class="title"> {{$t('message.title3')}}</div>
              <div class="content">{{$t('message.content5')}}</div>
              <div>
                <img class="banner2" style="margin-top:40px" src="../assets/324324.png" />
              </div>
            </div>
          </b-col>
          <!-- <b-col xl="6" md="12">
          <div class="grid-layout" style=" ">
            <div class="left">
              <img style="width:100%" src="../assets/3243333324.png" />
            </div>
            <div class="right">
              <div><img style="width:100%" src="../assets/3sf8.png" /></div>
              <div>
                <img style="width:100%" src="../assets/234e32432.png" />
              </div>
            </div>
          </div>
        </b-col> -->
        </b-row>
      </b-container>

      <div class="footer">
        <b-row style="margin-top:40px;margin-bottom:100px;    margin: 0 auto;">
          <b-col xl="6" md="12" class="">
            <div class="left">
              <div class="contact">{{$t('message.contactUs')}}</div>
              <div class="address-name">
                AGZZX OPTOELECTRONICS TECHNOLOGY CO., LTD <br />
                Floor 4, building 26#, JuYuanZhou, Jinshan Industrial Zone, Cangshan
                District, Fuzhou, Fujian, P.R.C. China
              </div>
              <div class="email">agservice@aigostar.com</div>

              <div class="privacy">
                <a :href="'https://aigosmartapp.aigostar.com/h5/#/privacy?language='+currentCode">
                  {{$t('message.privacy')}}</a>
              </div>
              <div class="policy">
                <a :href="'https://aigosmartapp.aigostar.com/h5/#/serviceAgreement?language='+currentCode">{{$t('message.policy')}}</a>
              </div>
              <div class="policy">
                <router-link style="cursor:pointer"  to="/userCancellationPage">
                  {{$t('v119.accountCancellation')}}
                </router-link>
              </div>

            </div>
          </b-col>
          <b-col xl="6" md="12">
            <div class="right">
              <img src="../assets/1232.png" />
              <div>{{$t('message.download')}} AigoSmart APP</div>
            </div>
          </b-col>
        </b-row>

      </div>
    </div>

    <!-- Wisdomleads -->
    <div class="content" v-else-if="brand=='Wisdomleads'">
      <div class="my-header">
        <img class="bg" src="../assets/300325168.png" alt="Fluid image" />

        <div class="logo-layout">
          <img class="logo2" src="../assets/smartadd.png" />
          <img class="glabol" src="../assets/asdcw.png" />

          <b-dropdown :text="currentLang" variant="red" class="m-2" style="margin-bottom:-10px" menu-class="lauange">
            <b-dropdown-item href="#" @click="changeLang('zh-ch', '中文')">中文</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('es', 'Español')">Español</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('fr', 'Français')">Français</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('de', 'Deutsch')">Deutsch</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('en', 'English')">English</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pt', 'Português')">Português</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('it', 'Italiano')">Italiano</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nl', 'Nederland')">Nederland</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pl', 'Polska')">Polska</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('da', 'Denmark')">Denmark</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nb', 'Norway')">Norway</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('sv', 'Sverige')">Sverige</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('hu', 'Magyarország')">Magyarország</b-dropdown-item>

          </b-dropdown>
        </div>
      </div>
      <!-- 手机头部 -->
      <div class="mobile-header">
        <div class="left">
          <img class="img-w" src="../assets/smartadd.png" />
        </div>
        <div class="right">
          <img style="width: 25px;height: 24px;margin-top: 22px; margin-right: -7px;" src="../assets/asdcw.png" />
          <b-dropdown :text="currentLang" variant="red" class="m-2" style="margin-bottom:-10px" menu-class="lauange">
            <b-dropdown-item href="#" @click="changeLang('zh-ch', '中文')">中文</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('es', 'Español')">Español</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('fr', 'Français')">Français</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('de', 'Deutsch')">Deutsch</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('en', 'English')">English</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pt', 'Português')">Português</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('it', 'Italiano')">Italiano</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nl', 'Nederland')">Nederland</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('pl', 'Polska')">Polska</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('da', 'Denmark')">Denmark</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('nb', 'Norway')">Norway</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('sv', 'Sverige')">Sverige</b-dropdown-item>
            <b-dropdown-item href="#" @click="changeLang('hu', 'Magyarország')">Magyarország</b-dropdown-item>

          </b-dropdown>
        </div>
      </div>
      <div class="mobile-banner">
        <img src="../assets/300325168.png" />

      </div>

      <b-container fluid class="bv-example-row">
        <b-row>
          <b-col xl="6" md="12">
            <div class="text-layout">
              <div class="title">{{$t('wisdomleads.title1')}}</div>
              <div class="content">
                {{$t('wisdomleads.content1')}}
              </div>
            </div>
          </b-col>
          <b-col xl="6" md="12">
            <div class="text-layout">
              <img class="banner1" src="../assets/smart.png" />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col xl="6" md="12">
            <div class="text-layout" style="justify-content: flex-end; height: 340px;">
              <img class="banner2" src="../assets/123193411.png" />
            </div>
          </b-col>
          <b-col xl="6" md="12">
            <div class="text-layout" style="justify-content: flex-end; height: 340px;">
              <div class="title"> {{$t('wisdomleads.title2')}}</div>
              <div class="content">
                {{$t('wisdomleads.content2')}}
              </div>
              <div class="content" style="margin-top:5px">
                {{$t('wisdomleads.content3')}}<img class="amazon" src="../assets/amze.png" />
                {{$t('wisdomleads.content4')}}
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row style="margin-top:40px;margin-bottom:100px">
          <b-col xl="6" md="12">
            <div class="text-layout" style="justify-content: flex-end;">
              <div class="title"> {{$t('wisdomleads.title3')}}</div>
              <div class="content">{{$t('wisdomleads.content5')}}</div>
              <div>
                <img class="banner2" style="margin-top:40px" src="../assets/324324.png" />
              </div>
            </div>
          </b-col>

        </b-row>
      </b-container>

      <div class="footer">
        <b-row style="margin-top:40px;margin-bottom:100px;    margin: 0 auto;">
          <b-col xl="6" md="12" class="">
            <div class="left">
              <div class="contact">{{$t('wisdomleads.contactUs')}}</div>
              <div class="address-name">
                AGZZX OPTOELECTRONICS TECHNOLOGY CO., LTD <br />
                Floor 4, building 26#, JuYuanZhou, Jinshan Industrial Zone, Cangshan
                District, Fuzhou, Fujian, P.R.C. China
              </div>
              <div class="email">agservice@aigostar.com</div>

              <div class="privacy">
                <a :href="'https://aigosmartapp.aigostar.com/h5/#/privacy?tenantId=1001&language='+currentCode">
                  {{$t('wisdomleads.privacy')}}</a>
              </div>
              <div class="policy">
                <a :href="'https://aigosmartapp.aigostar.com/h5/#/serviceAgreement?tenantId=1001&language='+currentCode">{{$t('wisdomleads.policy')}}</a>
              </div>
              <div class="policy">
                <router-link style="cursor:pointer"  to="/userCancellationPage">
                  {{$t('v119.accountCancellation')}}
                </router-link>
              </div>

            </div>
          </b-col>
          <b-col xl="6" md="12">
            <div class="right">
              <img src="../assets/wisdomleads-qc.png" />
              <div>{{$t('wisdomleads.download')}} wisdomleads APP</div>
            </div>
          </b-col>
        </b-row>

      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" :width="dialogWidth">
      <user-cancellation v-if="dialogVisible" @close="cancellationClose" />

    </el-dialog>

  </div>
</template>

<script>
// @ is an alias to /src
import config from '@/utils/config'
import utils from '@/utils/utils'
import cache from '@/utils/cache'
import UserCancellation from '@/components/UserCancellation'
export default {
  name: "Home",
  components: {
    UserCancellation
  },
  data() {
    return {
      dialogWidth:"50%",
      dialogVisible: false,
      brand: config.brand,
      currentLang: "English",
      currentCode: "en",
      langKey: [
        { "key": "zh-cn", "value": "中文" },
        { "key": "es", "value": "Español" },
        { "key": "fr", "value": "Français" },
        { "key": "de", "value": "Deutsch" },
        { "key": "en", "value": "English" },
        { "key": "pt", "value": "Português" },
        { "key": "it", "value": "Italiano" },
        { "key": "pl", "value": "Polska" },
        { "key": "nl", "value": "Nederland" },

        { "key": "da", "value": "Denmark" },
        { "key": "nb", "value": "Norway" },
        { "key": "sv", "value": "Sverige" },
        { "key": "hu", "value": "Magyarország" },

    
      ]
    };
  },
  mounted() {
    let lang = this.convertZh(navigator.language);//获取浏览器配置语言，支持非IE浏览器
    console.info("原始"+lang)
    console.info("转换后"+this.convertZh(lang))
    this.currentCode = lang;
    this.$i18n.locale = this.convertZh(this.currentCode);
    cache.setStr(config.lang,  this.currentCode);
    cache.setStr(config.brandKey,this.brand),
    console.info(utils.findArryValue(this.langKey, "key", lang).value)
    this.currentLang = utils.findArryValue(this.langKey, "key", lang).value

    let userAgent= navigator.userAgent
    if (utils.isMoible(userAgent)) {
        this.dialogWidth = "100%"
    }
    else{
      this.dialogWidth = "50%"
    }

  },
  methods: {


    //关闭弹窗
    cancellationClose() {
      this.dialogVisible = false;
    },
    changeLang(code, lang) {
      this.currentLang = lang;
      this.currentCode = code;
      this.$i18n.locale = this.convertZh(code);
      cache.setStr(config.lang,  this.currentCode);
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  background: white;
  margin: 0 auto;
  text-align: center;
}

.mobile-header {
  display: none;
}
a {
  color: white;
}
$highlight-color: #f90;
.content {
  //  max-width:  1900px;
  margin: 0 auto;
}
.my-header {
  //  max-width: 1000;
  position: relative;
  .bg {
    width: 100%;
    // max-width: 1915px;
    height: 650px;
    object-fit: cover;
  }
}
.mobile-banner {
  display: none;
}
.logo-layout {
  display: flex;
  z-index: 10;
  position: absolute;
  top: 10%;
  left: 17%;
  .logo {
    width: 200px;
  }
  .logo2 {
    width: 70px;
    height: 70px;
  }
  .glabol {
    width: 27px;
    height: 27px;
    margin-left: 15px;
    margin-top: 22px;
  }
}

// .lauange{
//   background: red;
// }

// .btn-light{
//   background:red;
//   border-color: none;
// }
// .btn-light.dropdown-toggle{
//     background-color: none;
//   border-color: none;
// }

.text-layout {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // padding-top: 150px;
  .title {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1e2225;
    text-align: left;
    width: 65%;
  }
  .content {
    font-size: 15px;
    font-family: Microsoft YaHei;
    text-align: left;
    color: #1e2225;
    width: 65%;
    margin-top: 15px;
  }

  .banner1 {
    width: 50%;
    max-width: 400px;
  }
  .banner2 {
    width: 80%;
    // max-width: 400px;
  }
  .amazon {
    width: 50px;
    margin-left: 3px;
    margin-right: 3px;
  }

  .team {
    width: 100%;
  }
}

.grid-layout {
  display: flex;
  width: 80%;
  height: 500px;
  align-items: flex-end;

  .left {
    width: 50%;
  }
  .right {
    width: 50%;
  }
}

.footer {
  // width: 1918px;
  min-height: 450px;
  background: #00263a;
  display: flex;
  // padding-left: 10%;
  // padding-right: 10%;
  padding-top: 100px;
  .left {
    text-align: left;
    color: #ffffff;
    // width: 50%;
    .contact {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    .address-name {
      color: #ffffff;
      font-size: 14px;
      margin-top: 20px;
    }
    .email {
      margin-top: 20px;
      color: #ffffff;
    }
    .privacy {
      margin-top: 30px;
    }
  }

  .right {
    display: flex;
    flex-direction: column;
    // width: 50%;
    // justify-content: center;
    align-items: center;
    color: white;

    img {
      width: 100px;
      height: 100px;
      // margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}
@media screen and (min-width: 500px) and (max-width: 768px) {
  @import "../assets/scss/home768.scss";
}

@media screen and (max-width: 500px) {
  @import "../assets/scss/home.scss";
}
</style>
